import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { 
  SiteSettingsProvider, 
  LanguageProvider, 
  CurrencyProvider, 
  InstrumentProvider, 
  CartProvider, 
  WishlistProvider, 
  CompareProvider 
} from './contexts/SiteContexts';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { MainContent } from './components/MainContent';
import { StabilityManager } from './components/utils/StabilityManager';
import { GlobalErrorLogger } from './components/utils/GlobalErrorLogger';

import { ErrorBoundary } from './components/utils/ErrorBoundary';

export default function App() {
  return (
    <Router>
      <NotificationProvider>
        <AuthProvider>
          <SiteSettingsProvider>
            <InstrumentProvider>
              <WishlistProvider>
                <CompareProvider>
                  <LanguageProvider>
                    <CurrencyProvider>
                      <CartProvider>
                        <Toaster position="top-center" />
                        <div className="relative min-h-screen bg-white">
                          <GlobalErrorLogger />
                          <ErrorBoundary>
                            <MainContent />
                          </ErrorBoundary>
                          <StabilityManager />
                        </div>
                      </CartProvider>
                    </CurrencyProvider>
                  </LanguageProvider>
                </CompareProvider>
              </WishlistProvider>
            </InstrumentProvider>
          </SiteSettingsProvider>
        </AuthProvider>
      </NotificationProvider>
    </Router>
  );
}
